export default __webpack_public_path__ + "static/media/nyc1.14441ba4.jpg";